import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import Icon from '../../../base/icons/components/Icon';
import { IconCloseLarge } from '../../../base/icons/svg';
const useStyles = makeStyles()((theme) => {
    return {
        container: {
            position: 'fixed',
            bottom: '24px',
            right: '24px',
            width: '320px',
            backgroundColor: '#FF6B6B',
            borderRadius: '12px',
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.25)',
            zIndex: 1000,
            overflow: 'hidden',
            animation: 'slideIn 0.3s ease-out',
            '@media (max-width: 768px)': {
                bottom: '16px',
                right: '16px',
                left: '16px',
                width: 'auto'
            }
        },
        containerHiding: {
            animation: 'slideOut 0.3s ease-in'
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '12px 16px',
            backgroundColor: 'rgba(0, 0, 0, 0.1)'
        },
        title: {
            fontSize: '0.9rem',
            fontWeight: 600,
            color: '#fff',
            margin: 0
        },
        closeButton: {
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '4px',
            transition: 'background 0.2s',
            '&:hover': {
                background: 'rgba(255, 255, 255, 0.2)'
            },
            '& svg': {
                fill: '#fff'
            }
        },
        content: {
            padding: '12px 16px'
        },
        message: {
            fontSize: '0.85rem',
            lineHeight: 1.5,
            color: '#fff',
            marginBottom: '12px'
        },
        button: {
            width: '100%',
            padding: '8px',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            color: '#FF6B6B',
            border: 'none',
            borderRadius: '6px',
            fontSize: '0.85rem',
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'all 0.2s',
            '&:hover': {
                backgroundColor: '#fff',
                transform: 'translateY(-1px)',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)'
            }
        },
        '@keyframes slideIn': {
            '0%': {
                transform: 'translateX(400px)',
                opacity: 0
            },
            '100%': {
                transform: 'translateX(0)',
                opacity: 1
            }
        },
        '@keyframes slideOut': {
            '0%': {
                transform: 'translateX(0)',
                opacity: 1
            },
            '100%': {
                transform: 'translateX(400px)',
                opacity: 0
            }
        }
    };
});
const RoomTimeLimitWarningNotification = ({ onClose }) => {
    const { t } = useTranslation();
    const { classes, cx } = useStyles();
    const [isHiding, setIsHiding] = useState(false);
    const handleClose = useCallback(() => {
        setIsHiding(true);
        setTimeout(() => {
            onClose();
        }, 300);
    }, [onClose]);
    useEffect(() => {
        // Auto-close after 10 seconds
        const timer = setTimeout(() => {
            handleClose();
        }, 10000);
        return () => clearTimeout(timer);
    }, [handleClose]);
    return (React.createElement("div", { className: cx(classes.container, isHiding && classes.containerHiding) },
        React.createElement("div", { className: classes.header },
            React.createElement("h3", { className: classes.title }, t('roomTimeLimit.warningTitle')),
            React.createElement("button", { className: classes.closeButton, onClick: handleClose, type: 'button' },
                React.createElement(Icon, { size: 18, src: IconCloseLarge }))),
        React.createElement("div", { className: classes.content },
            React.createElement("div", { className: classes.message }, t('roomTimeLimit.warningMessage')),
            React.createElement("button", { className: classes.button, onClick: handleClose, type: 'button' }, t('roomTimeLimit.understood')))));
};
export default RoomTimeLimitWarningNotification;
